// Header.js
const Header = ({title}) => {
	return (
		<h1>{title}</h1>
	)
}
Header.defaultProps = {
	title: 'World Traveler'
}
export default Header